import type { TrailSearchResult as AlgoliaTrail } from '@alltrails/types/AlgoliaResults';

export type MapBounds = {
  topLeftLat: string;
  topLeftLng: string;
  bottomRightLat: string;
  bottomRightLng: string;
};

const COLLAPSED_AXIS_PADDING = 0.02;

const getTrailResultsBounds = (trails?: AlgoliaTrail[]): MapBounds | undefined => {
  const points = (trails ?? []).map(trail => trail._geoloc).filter((geo): geo is { lat: number; lng: number } => Boolean(geo));

  if (points.length === 0) {
    return undefined;
  }

  let minLat = points[0].lat;
  let maxLat = points[0].lat;
  let minLng = points[0].lng;
  let maxLng = points[0].lng;

  points.forEach(({ lat, lng }) => {
    minLat = Math.min(minLat, lat);
    maxLat = Math.max(maxLat, lat);
    minLng = Math.min(minLng, lng);
    maxLng = Math.max(maxLng, lng);
  });

  if (minLat === maxLat) {
    minLat -= COLLAPSED_AXIS_PADDING;
    maxLat += COLLAPSED_AXIS_PADDING;
  }
  if (minLng === maxLng) {
    minLng -= COLLAPSED_AXIS_PADDING;
    maxLng += COLLAPSED_AXIS_PADDING;
  }

  return {
    topLeftLat: String(maxLat),
    topLeftLng: String(minLng),
    bottomRightLat: String(minLat),
    bottomRightLng: String(maxLng)
  };
};

export default getTrailResultsBounds;
